import { render, staticRenderFns } from "./DriverApproval.vue?vue&type=template&id=1eb807cd&scoped=true"
import script from "./DriverApproval.vue?vue&type=script&lang=js"
export * from "./DriverApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb807cd",
  null
  
)

export default component.exports